import React, { useRef, useEffect, useState } from 'react';
import { useInView } from 'framer-motion';
import { Container, Eyebrow, Reveal } from './landing/primitives';

const stats = [
  { value: 10, suffix: 'B+', label: 'Tokens processed', sub: 'Securely, every month' },
  { value: 99.99, suffix: '%', label: 'Platform uptime', sub: 'Enterprise SLA' },
  { value: 42, suffix: 'ms', label: 'Median latency', sub: 'Time to first token' },
  { value: 150, suffix: '+', label: 'Enterprise clients', sub: 'Across 12 industries' },
];

const Counter = ({ value, suffix, inView }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = Date.now();
    const step = () => {
      const p = Math.min((Date.now() - start) / 1800, 1);
      setCount(value * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, value]);
  const display = Number.isInteger(value) ? Math.round(count) : count.toFixed(2);
  return (
    <span className="text-5xl lg:text-6xl font-heading font-medium tracking-tight text-content tabular-nums">
      {display}<span className="text-content-3">{suffix}</span>
    </span>
  );
};

const Metrics = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="py-24 lg:py-32 border-t border-line bg-app-alt" data-testid="metrics-section">
      <Container>
        <Reveal><Eyebrow>By the numbers</Eyebrow></Reveal>
        <div ref={ref} className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line">
          {stats.map((s, idx) => (
            <Reveal key={s.label} delay={idx * 0.08} className="bg-app-alt p-8 lg:p-10" data-testid={`metric-${idx}`}>
              <Counter value={s.value} suffix={s.suffix} inView={inView} />
              <p className="mt-5 text-sm font-medium text-content">{s.label}</p>
              <p className="mt-1 text-xs text-content-3">{s.sub}</p>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Metrics;
